// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem_NavItem__2Bqas","active":"NavItem_active__2MTP4"};